import { render, staticRenderFns } from "./RequestCallWings.vue?vue&type=template&id=ec2548ee&"
import script from "./RequestCallWings.vue?vue&type=script&lang=js&"
export * from "./RequestCallWings.vue?vue&type=script&lang=js&"
import style0 from "./RequestCallWings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports